import { registerIconAlias } from '@uifabric/styling/lib/index';
registerIconAlias('trash', 'delete');
//# sourceMappingURL=icon-aliases.js.map